import dicomParser from "dicom-parser";

export const fetchAndParseMetaData = async (imageUrl: string) => {
  const image = await fetch(imageUrl);
  const arrayBuffer = await image.arrayBuffer();
  const byteArray = new Uint8Array(arrayBuffer);
  const dataSet = dicomParser.parseDicom(byteArray);
  return dataSet;
};
